import React, { useEffect, useState } from "react";

const ITEMS = [
  {
    quote:
      "Ozzy ships. He took a brittle Shopify theme and turned it into a proper, performant storefront — without the drama. Communication was sharp and on time.",
    name: "E-commerce Lead",
    role: "DTC brand · USA",
    avatar: "EL",
  },
  {
    quote:
      "Rare to find a developer who treats performance and SEO as features, not afterthoughts. Our Lighthouse and conversion both went up the same week.",
    name: "Founder",
    role: "B2C startup · UK",
    avatar: "FO",
  },
  {
    quote:
      "From Liquid edge cases to Node APIs, he handled the whole stack. Solid engineering, solid taste — exactly the combo we needed.",
    name: "CTO",
    role: "SaaS · EU",
    avatar: "CT",
  },
];

export default function Testimonials() {
  const [i, setI] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setI((v) => (v + 1) % ITEMS.length), 6000);
    return () => clearInterval(id);
  }, []);

  const current = ITEMS[i];

  return (
    <section className="section" id="words">
      <div className="container-x">
        <div className="section-head reveal">
          <div className="section-head__title">
            <span className="eyebrow">Kind words</span>
            <h2>
              What people
              <br />
              <span className="it text-accent">say.</span>
            </h2>
          </div>
          <div className="section-head__aside">
            <p>Excerpts from clients, teammates and project leads I've worked with.</p>
            <div className="flex gap-12" style={{ marginTop: 16 }}>
              {ITEMS.map((_, idx) => (
                <button
                  key={idx}
                  type="button"
                  aria-label={`Show testimonial ${idx + 1}`}
                  onClick={() => setI(idx)}
                  className="chip"
                  style={{
                    cursor: "pointer",
                    background: idx === i ? "var(--accent)" : "transparent",
                    color: idx === i ? "#0a0a0a" : "var(--text-soft)",
                    borderColor: idx === i ? "var(--accent)" : "var(--border-strong)",
                  }}
                >
                  <span className="dot" style={{ background: idx === i ? "#0a0a0a" : "var(--accent)" }} />
                  0{idx + 1}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="testimonial reveal" key={i}>
          <p className="testimonial__quote">{current.quote}</p>
          <div className="testimonial__author">
            <span className="avatar">{current.avatar}</span>
            <div>
              <div className="name">{current.name}</div>
              <div className="role">{current.role}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
